import { LazyLoadImage } from "@root/shared/components/LazyLoadImage";
import { type ComponentProps, type FC } from "react";
import * as styles from "./styles.css";

type Props = {
  url: string;
  gaAction: string;
  gaLabel: string;
  query: string;
  premiumImage: ComponentProps<typeof LazyLoadImage>;
  handleClickPremiumBanner: () => void;
};

export const PremiumBanner: FC<Props> = ({
  url,
  gaAction,
  gaLabel,
  query,
  premiumImage,
  handleClickPremiumBanner,
}) => (
  <a
    href={url}
    className={styles.link}
    data-ga-action={gaAction}
    data-ga-label={gaLabel}
    data-query-str={query}
    onClick={handleClickPremiumBanner}
  >
    <LazyLoadImage {...premiumImage} />
  </a>
);
